/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Title_CourseInputs */

const en_title_course = /** @type {(inputs: Title_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course`)
};

const ja_title_course = /** @type {(inputs: Title_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コース`)
};

const fr_title_course = /** @type {(inputs: Title_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours`)
};

const de_title_course = /** @type {(inputs: Title_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurs`)
};

/**
* | output |
* | --- |
* | "Course" |
*
* @param {Title_CourseInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const title_course = /** @type {((inputs?: Title_CourseInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Title_CourseInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_title_course(inputs)
	if (locale === "ja") return ja_title_course(inputs)
	if (locale === "fr") return fr_title_course(inputs)
	return de_title_course(inputs)
});